import { apolloProvider } from '@/plugins/apollo';
import userFeatures from '@/api/features/userFeatures.gql';
import boxFeatures from '@/api/features/boxFeatures.gql';

async function getAvailableFeatures() {
  const { data } = await apolloProvider.defaultClient.query({ query: userFeatures });
  return (((data || {}).koeeBoxQuery || {}).featuresByUser || []).map((f) => f.code);
}

async function getAvailableBoxFeatures(deviceId) {
  const { data } = await apolloProvider.defaultClient.query({
    query: boxFeatures,
    variables: { deviceId },
  });
  return (((data || {}).koeeBoxAnonymousQuery || {}).featuresByBox || []).map((f) => f.code);
}

export default {
  state: {
    userFeatures: [],
    boxFeatures: new Map(),
  },
  mutations: {
    SET_AVAILABLE_FEATURES(state, payload) {
      state.userFeatures = payload;
    },
    SET_BOX_FEATURE(state, payload) {
      state.boxFeatures.set(payload.deviceId, payload.features);
      //TODO: Подумать как переделать
      state.boxFeatures = new Map(state.boxFeatures);
    },
  },
  actions: {
    async SET_AVAILABLE_FEATURES({ commit, getters }) {
      if (getters.userId) {
        commit('SET_AVAILABLE_FEATURES', await getAvailableFeatures());
      }
    },
    async SET_BOX_FEATURE({ commit }, payload) {
      const { deviceId } = payload || {};
      if (deviceId) {
        commit('SET_BOX_FEATURE', { deviceId, features: [] });
        const features = await getAvailableBoxFeatures(deviceId);
        commit('SET_BOX_FEATURE', { deviceId, features });
      }
    },
  },
  getters: {
    userFeatures(state) {
      return state.userFeatures || [];
    },
    boxFeatures(state) {
      return state.boxFeatures;
    },
  },
};
